import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import './detail.css';
import { useParams } from 'react-router-dom';
import { getBlogById, getPopularBlogs } from '../../../components/utility/utility';
import Header from '../../../components/blog/Header';
import MainBlog from './MainBlog';
import TrendingCarousel from '../../../components/blog/TrendingCarousel';

function BlogDetail() {
  const [blogs, setBlogs] = useState([]);
  const [allBlogs, setAllBlogs] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
const { slug } = useParams();


  useEffect(() => {
    window.scrollTo(0, 0); 

    const fetchBlogById = async () => {
      try {
        const blogData = await getBlogById(slug);
    
        if (blogData) {
          setBlogs(blogData); // Wrap in array if needed by child components
        } else {
          setError('Blog not found.');
        
        }
       
      } catch (err) {
        console.error('Error fetching blog by ID:', err);
        setError('Failed to load blog. Please try again later.');
        
      } finally{
        setLoading(false);
      }
    };

       const fetchPopularBlogs = async () => {
          try {
            const blogData = await getPopularBlogs()
            setAllBlogs(blogData);
            // setLoading(false);
          } catch (err) {
            console.error('Error fetching blogs:', err);
            setAllBlogs([]);
            // setLoading(false);
          }
        };
    
        fetchPopularBlogs(); 
    fetchBlogById();
  }, [slug]);

  // console.log("9999999999999",blogs)
  if (loading) {
    return  <div id="loader" class="loader"></div>;
  }

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>;
  }

  return (
    <div>
      {/* Header */}
      <Header />

      <div className="BlogDetail">
        <div className="comp-main">
          <div className="first">
            <MainBlog blogs={blogs} />
          </div>

          {
            allBlogs?.length > 1 && (
              <div className="second">
                <TrendingCarousel blogPosts={allBlogs} detail={true} />
                {/* <Comp2new blogs={blogs} /> */}
              </div>
            )
          }
          
        </div>

        {/* <div className="third">
          <Comp3 blogs={blogs} />
        </div> */}
        
      </div>
    </div>
  );
}

export default BlogDetail;